import { motion } from "framer-motion";

const LOGO_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_price-converter-12/artifacts/3z72kuf7_siiii.jpeg";

export const Header = () => (
  <header
    data-testid="app-header"
    className="sticky top-0 z-40 border-b border-[#E2E8F0] bg-white/80 backdrop-blur-md"
    style={{ backgroundImage: "linear-gradient(90deg, rgba(31,42,92,0.05), rgba(201,132,143,0.08))" }}
  >
    <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-5 py-3 sm:px-8">
      <motion.img
        initial={{ opacity: 0, x: -12 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
        src={LOGO_URL}
        alt="C&F Personal Shop"
        data-testid="header-logo"
        className="h-24 w-24 sm:h-32 sm:w-32 md:h-36 md:w-36 object-contain rounded-full"
      />
      <motion.div
        initial={{ opacity: 0, x: 12 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="text-right"
      >
        <h1
          data-testid="header-title"
          className="text-lg sm:text-2xl font-bold tracking-tight text-[#1F2A5C] leading-tight"
        >
          Calculadora de Precios
        </h1>
        <p data-testid="header-subtitle" className="text-[11px] sm:text-sm text-[#64748B] max-w-md">
          Calcula el costo final de tu compra desde Estados Unidos de forma rápida y sencilla.
        </p>
      </motion.div>
    </div>
  </header>
);
